import React, { useState, useEffect } from 'react';
import bg2 from '../assets/images/Blue_Bar_2.jpg';

const images = bg2

const BarHero = ({ language }) => {
 

 
  return (
    <section
      className="d-flex align-items-center text-white text-center"
      style={{
        backgroundImage: `url(${images})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '60vh',
        transition: 'background-image 1s ease-in-out',
        position: 'relative'
      }}
    >

    </section>
  );
};

export default BarHero;
